<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h4>Foto's</h4>
        <hr>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        Kies uitgelichte afbeelding
        <v-select :options="images" label="name" v-model="selected" :value="$store.myValue" @input="setSelected" class="mb-3">
          <template v-slot:option="option">
            <img :src="option.responsive.xs" :alt="option.name" class="img-thumbnail">
            {{ option.name }}
          </template>
        </v-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3" md="6" sm="12" v-for="item in images" :key="item.id" class="d-flex align-items-stretch">
        <div class="card rounded-0 w-100 bg-white">
          <span v-if="selected && selected.id === item.id" class="position-absolute float-right">
            <i class="fa fa-check-circle fa-2x text-success " aria-hidden="true"></i>
          </span>
        <img :src="item.responsive.md" class="card-img-top img-responsive w-100" :alt="item.id">
          <b-button @click="openRemoveModal(item)" variant="danger btn-sm"><i class="fa fa-trash"></i> Verwijder</b-button>
        </div>


      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="12">
        <h4>Overige bestanden</h4>
        <hr>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <ul class="list-group mb-5" >
          <li v-for="item in files" :key="item.id" class="list-group-item d-flex">

             <a :href="item.url" class="flex-grow-1" target="_blank">{{ item.name }}  </a>
            <b-button class="btn-sm btn-danger float-right hoverable" @click="openRemoveModal(item)">
              <i class="fa fa-trash"></i> Verwijder
            </b-button>

          </li>
        </ul>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12">
        <h4>Video's</h4>
        <hr>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <ul class="list-group mb-5" >
          <li v-for="item in videos" :key="item.id" class="list-group-item d-flex">
            <span style="line-height: 28px;" class="mr-2">{{ item.url }}</span>

            <b-button class="btn-sm btn-danger float-right hoverable" @click="openRemoveVideoModal(item)">
              <i class="fa fa-trash"></i> Verwijder
            </b-button>
          </li>
        </ul>
      </b-col>
    </b-row>

    <b-modal ref="remove-file" id="remove-file" title="Bestand verwijderen">
      <p class="my-4">Weet je zeker dat je <strong>"{{deletable.name}}"</strong> wilt verwijderen? Deze actie is
        onomkeerbaar.</p>
      <template v-slot:modal-footer>
        <b-button @click="hideModal">Nee</b-button>
        <b-button variant="danger" @click="deleteFile">Ja, verwijder</b-button>
      </template>
    </b-modal>

    <b-modal ref="remove-video" id="remove-file" title="Video verwijderen">
      <p class="my-4">Weet je zeker dat je <strong v-if="video_to_delete">"{{video_to_delete.url}}"</strong> wilt verwijderen? Deze actie is onomkeerbaar.</p>
      <template v-slot:modal-footer>
        <b-button @click="hideRemoveVideoModal">Nee</b-button>
        <b-button variant="danger" @click="deleteVideo">Ja, verwijder</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>

import {deleteItem, updateData} from "@/api";

export default {
  props: ['files', 'images', 'featured_image', 'videos'],
  data() {
    return {
      deletable: {},
      video_to_delete: null,
      selected: this.featured_image ? this.featured_image : null,
    }
  },
  // computed: {
  //   model: {
  //     get() { return this.value },
  //     set(v) { this.$emit("input", v) }
  //   },
  //
  //   documents: function(){
  //     return this.model.map(document => {
  //       if(this.documentTypes.hasOwnProperty(document.type)) {
  //         document.type = this.documentTypes[document.type];
  //       }
  //
  //       return document;
  //     })
  //   },
  // },
  methods: {
    async setSelected(value) {
       const data = await updateData('projects/' + this.$route.params.id + '/media/' + value.id , value).then(response => response.data);
      console.log(data)
       this.selected = value

    },


    deleteFile() {
      deleteItem(`projects/${this.$route.params.id}/media/${this.deletable.id}`).then(({data}) => {
        this.$refs['remove-file'].hide();
        this.model = data.data;
        this.$emit('deletedFile', data.deletedId)

      });
    },
    openRemoveModal(document) {
      this.deletable = document;

      this.$refs['remove-file'].show();
    },
    hideModal() {
      this.$refs['remove-file'].hide();
    },

    openRemoveVideoModal(video) {
      this.video_to_delete = video;
      this.$refs['remove-video'].show();
    },

    hideRemoveVideoModal() {
      this.video_to_delete = null;
      this.$refs['remove-video'].hide();
    },

    deleteVideo() {
      deleteItem(`projects/${this.$route.params.id}/videos/${this.video_to_delete.id}`).then(() => {
        this.$emit('deletedVideo', this.video_to_delete.id)

        this.hideRemoveVideoModal();
      });
    },
  }
}
</script>

<style>
.card-img-top {
  max-height: 150px;
  min-height: 150px;
  object-fit: cover;
}
</style>
